import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteNoteAction } from '../../../redux/actions/notesActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';

const DeleteNoteModal = ({ onModalClose, onModalSubmit, note }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setLoading(true);
    await dispatch(deleteNoteAction(note.id));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Видалення нотатки'}
      loading={loading}
      onClose={onModalClose}
      body={'Ви дійсно бажаєте видалити цю нотатку?'}
      actionButton={<Button onClick={onSubmit} disabled={loading} variant={'primary'} children={'Видалити'} />}
    />
  );
};

export default DeleteNoteModal;
